import { ComponentType } from 'react';

import AccordionBlock, { AccordionBlockProps } from 'components/ModularBlocks/AccordionBlock/AccordionBlock';
import AnimatedCards, { AnimatedCardsProps } from 'components/ModularBlocks/AnimatedCards';
import ArticleFeedBlock, { ArticleFeedBlockProps } from 'components/ModularBlocks/ArticleFeedBlock';
import ArticlesBlock, { ArticlesBlockProps } from 'components/ModularBlocks/ArticlesBlock/ArticlesBlock';
import AwardsBlock, { AwardsBlockProps } from 'components/ModularBlocks/AwardsBlock/AwardsBlock';
import BasicTableBlock, { BasicTableBlockProps } from 'components/ModularBlocks/BasicTableBlock';
import BasicTextBlock, { BasicTextBlockProps } from 'components/ModularBlocks/BasicTextBlock';
import BlockGroupStart, { BlockGroupStartProps } from 'components/ModularBlocks/BlockGroupStart';
import ComparisonTable, { ComparisonTableProps } from 'components/ModularBlocks/ComparisonTable';
import ContactForm, { ContactFormProps } from 'components/ModularBlocks/ContactForm';
import ContentCards, { ContentCardsProps } from 'components/ModularBlocks/ContentCards/ContentCards';
import DemoForm, { DemoFormProps } from 'components/ModularBlocks/DemoForm';
import Disclaimer, { DisclaimerProps } from 'components/ModularBlocks/Disclaimer';
import DocumentsBlock, { DocumentsBlockProps } from 'components/ModularBlocks/DocumentsBlock';
import FlexibleTabbed, { FlexibleTabbedProps } from 'components/ModularBlocks/FlexibleTabbed/FlexibleTabbed';
import FullBleedCta, { FullBleedCtaProps } from 'components/ModularBlocks/FullBleedCta/FullBleedCta';
import HelpCards, { HelpCardsProps } from 'components/ModularBlocks/HelpCards/HelpCards';
import IconCardBlock, { IconCardBlockProps } from 'components/ModularBlocks/IconCardBlock';
import LivePricingBlock, { LivePricingBlockProps } from 'components/ModularBlocks/LivePricingBlock/LivePricingBlock';
import MfeBlock, { MfeBlockProps } from 'components/ModularBlocks/MfeBlock/MfeBlock';
import PromotionBanners, { PromotionBannersProps } from 'components/ModularBlocks/PromotionBanners';
import Spacer, { SpacerProps } from 'components/ModularBlocks/Spacer';
import TabTable, { TabTableProps } from 'components/ModularBlocks/TabTable';
import TextBlock, { TextBlockProps } from 'components/ModularBlocks/TextBlock';
import TwoBlockContent, { TwoBlockContentProps } from 'components/ModularBlocks/TwoBlockContent/TwoBlockContent';
import WatchBlock, { WatchBlockProps } from 'components/ModularBlocks/WatchBlock/WatchBlock';

export interface ModularBlockI {
  accordionBlock: AccordionBlockProps;
  animatedCards: AnimatedCardsProps;
  basicTextBlock?: BasicTextBlockProps;
  basicTableBlock?: BasicTableBlockProps;
  contentCards?: ContentCardsProps;
  helpCards?: HelpCardsProps;
  flexibleTabbedTable?: FlexibleTabbedProps;
  twoBlockContent?: TwoBlockContentProps;
  promoBanner: PromotionBannersProps;
  disclaimer: DisclaimerProps;
  contactForm: ContactFormProps;
  demoForm: DemoFormProps;
  textBlock: TextBlockProps;
  fullBleedCta: FullBleedCtaProps;
  awardsBlock: AwardsBlockProps;
  tabTable: TabTableProps;
  articlesBlock: ArticlesBlockProps;
  articleFeedBlock: ArticleFeedBlockProps;
  watchBlock: WatchBlockProps;
  livePricingBlock: LivePricingBlockProps;
  documentBlock: DocumentsBlockProps;
  spacer: SpacerProps;
  blockGroupStart: BlockGroupStartProps;
  iconCardBlock: IconCardBlockProps;
  comparisonTable: ComparisonTableProps;
  mfeBlock: MfeBlockProps;
}

export type ModularBlockTypes = keyof ModularBlockI;

export const modularBlockComponents: { [key in ModularBlockTypes]?: ComponentType<any> } = {
  accordionBlock: AccordionBlock,
  animatedCards: AnimatedCards,
  basicTextBlock: BasicTextBlock,
  basicTableBlock: BasicTableBlock,
  contentCards: ContentCards,
  helpCards: HelpCards,
  flexibleTabbedTable: FlexibleTabbed,
  twoBlockContent: TwoBlockContent,
  textBlock: TextBlock,
  disclaimer: Disclaimer,
  contactForm: ContactForm,
  demoForm: DemoForm,
  promoBanner: PromotionBanners,
  fullBleedCta: FullBleedCta,
  awardsBlock: AwardsBlock,
  tabTable: TabTable,
  articlesBlock: ArticlesBlock,
  articleFeedBlock: ArticleFeedBlock,
  watchBlock: WatchBlock,
  livePricingBlock: LivePricingBlock,
  documentBlock: DocumentsBlock,
  spacer: Spacer,
  blockGroupStart: BlockGroupStart,
  iconCardBlock: IconCardBlock,
  comparisonTable: ComparisonTable,
  mfeBlock: MfeBlock,
};

// this will be removed very soon but in the meantime please add any new content blocks here as well as the data above
export const BlockTypes = {
  promotionBanners: 'promotionBanners',
  promotionBannerText: 'promotionBannerText',
  promotionBannerHeaderText: 'promotionBannerHeaderText',
  blockGroupStart: 'blockGroupStart',
  blockGroupEnd: 'blockGroupEnd',
  basicTextBlock: 'basicTextBlock',
  pricingTable: 'pricingTable',
  applesTable: 'applesTable',
  textBlock: 'textBlock',
  galleryCards: 'galleryCards',
  spacer: 'spacer',
  disclaimer: 'disclaimer',
  ctaBanner: 'ctaBanner',
  ctaButton: 'ctaButton',
  animatedCards: 'animatedCards',
  twoBlockContent: 'twoBlockContent',
  flexibleTabbedTable: 'flexibleTabbedTable',
  fullBleedBanner: 'fullBleedBanner',
  leadershipBio: 'leadershipBio',
  commissionBlock: 'commissionBlock',
  timelineBlock: 'timelineBlock',
  threeColumnBlock: 'threeColumnBlock',
  iconCardBlock: 'iconCardBlock',
  fullBleedTastyNation: 'fullBleedTastyNation',
  basicTableBlock: 'basicTableBlock',
  comparisonTable: 'comparisonTable',
  documentsBlock: 'documentsBlock',
  calloutBlock: 'calloutBlock',
  listBlock: 'listBlock',
  contentCards: 'contentCards',
  helpCards: 'helpCards',
  TwoBlockContent: 'twoBlockContent',
  AccordionBlock: 'accordionBlock',
  fullBleedCta: 'fullBleedCta',
  articlesBlock: 'articlesBlock',
  articleFeedBlock: 'articleFeedBlock',
  watchBlock: 'watchBlock',
  livePricingBlock: 'livePricingBlock',
  mfeBlock: 'mfeBlock',
};
